import { Box, Link as MuiLink, Typography } from '@mui/material';
import { format as dateFnsFormat } from 'date-fns';

import { Organization } from '@app/types/organization';
import { FULL_TIME_TERMS_URL } from '@app/utils/constants';

export interface FullTimeFeeNoticeProps {
  /** 同意内容表示に使用する、同意したユーザーのメールアドレス(呼び出し側で取得済みの値を渡す) */
  agreedByEmail?: string;
  /** 同意内容表示に使用する、利用規約に同意した日時(ISO文字列。呼び出し側で取得済みの値を渡す) */
  fullTimeTermsAgreedAt?: string;
  /** 'banner'の場合、利用規約に同意済みであればその同意内容を併せて表示する */
  organization?: Organization;
  /** 'banner':一覧画面上部の警告帯 / 'plain':ダイアログ内の本文 */
  variant?: 'banner' | 'plain';
}

/**
 * 常勤求人の採用成功報酬フィーについての注意文。
 * 掲載管理一覧(ProductManagement)と同意モーダル(FullTimeProductCreation)で
 * 同一文言を表示するため共通化している。
 */
export function FullTimeFeeNotice({
  agreedByEmail = '',
  fullTimeTermsAgreedAt,
  organization,
  variant = 'plain',
}: FullTimeFeeNoticeProps) {
  const text = (
    <Typography variant="body2" component="span" color="inherit">
      ProDoctorsで常勤求人を掲載・応募・採用された場合には、採用医師の年収に応じた採用成功報酬の費用を請求させていただきます。
      <br />
      {'御理解・ご了承の上ご利用ください。　費用の詳細については'}
      <MuiLink
        href={FULL_TIME_TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        // NOTE:親のcolor(赤)がcascadeするため!importantで明示的に上書きする
        sx={{ color: '#00E !important' }}
      >
        利用規約
      </MuiLink>
      をご確認ください。
    </Typography>
  );

  if (variant === 'plain') {
    return text;
  }

  return (
    <Box
      sx={(theme) => ({
        bgcolor: theme.customPalette.feeNoticeBackground,
        borderRadius: '10px',
        color: theme.customPalette.feeNoticeText,
        mb: 2,
        px: 2,
        py: 1,
      })}
    >
      {text}
      {organization && fullTimeTermsAgreedAt && (
        <>
          <br />
          <Box
            sx={(theme) => ({
              border: '1px solid',
              borderColor: theme.customPalette.agreementBorder,
              borderRadius: '15px',
              display: 'inline-block',
              mt: 1,
              px: 2,
              py: 0.5,
            })}
          >
            <Typography
              sx={(theme) => ({
                color: theme.customPalette.agreementText,
                fontSize: '14px',
              })}
            >
              {'クリニック：' +
                organization.name +
                '　ユーザー：' +
                agreedByEmail +
                ' が' +
                dateFnsFormat(
                  new Date(fullTimeTermsAgreedAt),
                  'yyyy/MM/dd HH:mm'
                ) +
                ' 画面上で承諾済み'}
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
}
